<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <AddEvent />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import AddEvent from "./components/AddEvent";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    AddEvent,
    // ProjectsTable,
  },
};
</script>
